<mat-toolbar class="flex-row">
  <button mat-button [matMenuTriggerFor]="fileMenu">File</button>
  <mat-menu #fileMenu="matMenu">
    <button mat-menu-item (click)="export.emit('json')">Export JSON</button>
    <button mat-menu-item (click)="import.click()">Import JSON</button>
    <input hidden (change)="fileChanged($event)" #import type="file" id="file" />
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="export.emit('qmd')">Export QModel</button>
    <button mat-menu-item (click)="export.emit('gmmodel')">Export GmModel</button>
    <button mat-menu-item (click)="export.emit('dxf')">Export Dxf</button>
    <button mat-menu-item (click)="export.emit('png')">Export Image/Png</button>
    <button mat-menu-item (click)="export.emit('jpg')">Export Image/Jpg</button>
    <button mat-menu-item (click)="export.emit('svg')">Export Image/Svg</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="preferences.emit()">Preferences</button>
    <button mat-menu-item (click)="about.emit()">About</button>
  </mat-menu>
  <button mat-button [matMenuTriggerFor]="addMenu">Add</button>
  <mat-menu #addMenu="matMenu">
    <button mat-menu-item (click)="addV3dObject.emit()">Visualize3D Object</button>
  </mat-menu>
  <button mat-button [matMenuTriggerFor]="editMenu">Edit</button>
  <mat-menu #editMenu="matMenu">
    <button mat-menu-item [disabled]="!selectedV3dObject" (click)="deleteV3dObject.emit()">Delete Object3D</button>
  </mat-menu>
  <button mat-button [matMenuTriggerFor]="viewMenu">View</button>
  <mat-menu #viewMenu="matMenu">
    <div (click)="$event.stopPropagation()">
      <mat-checkbox class="mat-menu-item" (change)="orthographicView.emit($event.checked)">Ortrhographic view</mat-checkbox>
    </div>
    <mat-divider></mat-divider>
    <div (click)="$event.stopPropagation()">
      <mat-checkbox class="mat-menu-item" (change)="fitChange.emit($event.checked)">Fit Object3D in view</mat-checkbox>
    </div>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="viewChange.emit(null)">Free camera</button>
    <button *ngFor="let key of enumKeys(viewPoint)" mat-menu-item (click)="viewChange.emit(viewPoint[key])">{{ key }}</button>
  </mat-menu>
  <div class="cf-flex-auto"></div>
  <img class="magicore-logo" src="assets\magicore_logo_horizontal_tagline_white.png" />
  <button (click)="refresh.emit()" mat-button matTooltip="Re-load scene">
    <mat-icon aria-hidden="false" aria-label="refresh">refresh</mat-icon>
  </button>
  <mat-spinner [style.visibility]="api.isLoading ? 'visible' : 'hidden'" diameter="25"></mat-spinner>
</mat-toolbar>
